const keySkillsForMarketingAutomationTeam = [
  {
    type: "paragraph",
    text: "Marketing role is a highly people oriented role. Admittedly, there is lot of technology which is now involved in marketing, yet, it’s the people who finally make strategic decisions. It is the people in the team who are vital to demand generation strategy and are supported by marketing automation tools and technologies.",
  },
  {
    type: "paragraph",
    text: "Marketing automation requires people who have variety of skills and passion to learn, and work with new technology. It is not always possible for a medium to small business, to build a large team to focus only on automation. Hence each person in the automation team, must play multiple roles, to keep it efficient. Coupled with a fact that the automation software and platforms are evolving to cover deeper, more complex interactions with customer, the marketing team is always learning new ways to connect with the customer.",
  },
  {
    type: "paragraph",
    text: "There is a dearth of people out there in the market, who have enough experience in marketing automation and the ever evolving, associated platforms. The automation teams must keep themselves updated to stay at the top of their game. This is true not only for the technology skills, which is obvious, but also for the marketing skills, which is what these teams are primarily about. This calls for certain attitude and aptitude that every team member must have, before he joins your automation team. The key skills to look for, in every team member are:",
  },

  {
    type: "list",
    items: [
      "Passion for learning technology – Every individual will be working with multiple platforms and technologies. Besides, the software will keep evolving and every team member needs to take initiative to learn and update himself.",
      "Eager to learn and experiment with new technology come new possibilities. The automation team must figure out the best way to use these automation tools to get maximum impact and maximum benefit to the business.",
      "Curiosity about customer behaviour. After All, this is a marketing role. Customer is in the centre of every marketing activity. Every automation action must be taken, keeping the customer in mind. If you fail to excite the customer and bring him in, the automation serves no purpose.",
      "Strong communication skills. Now this is of prime importance for a marketing professional and very specially the written communication skills. The message passed must be clear, precise and concise. It must evoke a positive emotion and motivate the customer to take an action towards your organization’s benefit.",
      "Strong analytical skills. Progress of each activity needs to be tracked and results need to be analysed to identify what is working and what is not. If something isn’t working, then the reasons for its failure must be identified. That calls for strong analytical skills.",
      "Management skills. Marketing automation team is usually small. They work on multiple projects at the same time. Each member of the team may be running multiple projects individually. They must have the project management skills to effectively execute each initiative, individually.",
    ],
  },

  {
    type: "paragraph",
    text: "Apart from these skills, for the marketing automation team to stay efficient, it comprises of a few dedicated roles that perform specific tasks.",
  },

  {
    type: "heading",
    text: "Marketing automation Manager.",
  },
  {
    type: "paragraph",
    text: "This is a key role to get the automation operations right. This is the guy that will set up the automation technology framework. He will setup and operate the content management systems for your company. He is the guy who will get under the hood, integrate systems and get them to work together. He must love technology and the processes. Not only will he ensure that lights are on and bright in the automation world, he is also the one who will extract the data for performance reports of your marketing initiatives. To set the right framework and objectives right and built them into the system, he must understand marketing and its processes. He must possess following skills at the bare minimum.",
  },
  {
    type: "list",
    items: [
      "Good understanding of Digital marketing",
      "Excellent technical skills on marketing Automation platforms",
      "Good CRM platform skills",
      "Web development and design skills (Web design, page layout)",
      "Deep understanding of marketing processes and Lead generation",
      "Integration skills (Integrating CRM, with automation with social media)",
    ],
  },

  {
    type: "heading",
    text: "Content Manager",
  },
  {
    type: "paragraph",
    text: "This is the next most important role. In the world of digital marketing, content is King. Content is what will attract your target client to your business. The content in your emails, your website, your social media posts must be relevant to the customer. It should convey the maximum meaning in minimum time. The message should not only be clear, concise and actionable but should also be interesting enough to keep the customer hooked. He must understand the company’s product and how to present it across various media to different segments. He must also understand the objectives of each campaign to create the relevant content for that campaign. The Content manager must have excellent communication skills. In a nutshell, he is the one who will build the story and tell it to the customer. Your customers will make their impression about your business, based on his story. A skilled content manager should possess a sound understanding of following",
  },
  {
    type: "list",
    items: [
      "Customer personas",
      "Brand positioning.",
      "Content creation.",
      "Communication skills",
      "Product evangelist.",
      "Social media skills",
    ],
  },

  {
    type: "heading",
    text: "Campaign Manager",
  },
  {
    type: "paragraph",
    text: "Campaign Managers run and design the marketing programs on automation platform. They plan, develop, rollout and measure results. They decide what key message they will be sending out in each campaign. They define the campaign’s customer segments and what messaging will go in each campaign for each platform. They work closely with the automation manager and content manager to target the right customer segment with right message. They also need to have the analytical skills to measure the results of campaign and analyse its success to understand what worked and what didn’t. They are highly analytical and measure the results such as qualified leads, pipeline value, revenue results etc. They bring the marketing into the marketing automation and keep it focused on its objective, which is to bring in more customers. At the minimum they should have following skills.",
  },
  {
    type: "list",
    items: [
      "Customer Marketing",
      "Campaign management",
      "Multi-channel marketing",
      "Buyer persona mapping",
      "Measuring results",
      "Analytical skills",
      "Sales enablement.",
    ],
  },

  {
    type: "paragraph",
    text: "These are by no means the only roles in the marketing. You can define more roles as the scale increases or complexity varies. Also, these roles are not always segregated. Many a times there will be an overlap amongst these roles. One must understand that marketing automation requires technical skill and understanding of digital world, but at the end of the day, it is about bringing in the customers which is still pure marketing.",
  },
];

export default keySkillsForMarketingAutomationTeam;
